import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Loader from '../../common/Loader';
import Attachments from './Attachments';
import Consents from './Consents';
import PaperConsents from './PaperConsents';
import { enhance } from './enhance';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { usePageView } from '../../../hocs/usePageView';

const ProfileDocumentation = ({
  intl: { formatMessage },
  isLoading,
  userId,
}) => {
  usePageView('Profile | Documentation');

  return (
    <div styleName="content content--info">
      <MetaHelmet title="pages.title.profile.documents" />

      <div
        styleName={cn('info info--docs', {
          'info--disabled': isLoading,
        })}
      >
        <If condition={isLoading}>
          <Loader className="g-centeredAll" />
        </If>
        <Consents formatMessage={formatMessage} />
        <PaperConsents formatMessage={formatMessage} />
        <Attachments userId={userId} formatMessage={formatMessage} />
      </div>
    </div>
  );
};

ProfileDocumentation.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  isLoading: PropTypes.bool,
  userId: PropTypes.number,
};

export default enhance(ProfileDocumentation);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/index.jsx